import axios from 'axios';
import Endpoints from '../Endpoints';

export const listOrders = async (params = {}) => {
  const { data } = await axios.get(Endpoints.Orders.LIST, { params });
  // Normalize to return the inner payload (many endpoints wrap responses as { code, status, data })
  return data?.data ?? data;
};

export const getOrder = async (id) => {
  const { data } = await axios.get(Endpoints.Orders.SINGLE + id);
  // Backend may return { data: { order, notification } } — return the order object for components
  return data?.data?.order ?? data?.data ?? data;
};

export const updateOrderStatus = async (id, status) => {
  const { data } = await axios.put(Endpoints.Orders.UPDATE_STATUS + id + '/status', { status });
  return data?.data ?? data;
};

export const reorder = async (id) => {
  const { data } = await axios.post(Endpoints.Orders.SINGLE + id + '/reorder');
  return data?.data ?? data;
};
